import type { ChangelogEntry } from "../types";

/** @-tagging manglet i svarfeltet under en kommentar i Prosjektoppdateringer. */
export const TAGGING_I_SVAR_2026_10: ChangelogEntry = {
  id: "2026-10-23-tagging-i-svar",
  date: "2026-10-23",
  title: "Tagg kolleger også når du svarer på en kommentar",
  summary: "Svarfeltet i Prosjektoppdateringer har nå samme @-tagging som hovedfeltet.",
  sections: [
    {
      heading: "Prosjektoppdateringer",
      minRole: "user",
      items: [
        {
          title: "@ virker i svar",
          kind: "rettet",
          body: "Skriver du @ i svarfeltet under en kommentar, får du nå opp personlisten, med piltaster, Enter og Escape som i hovedfeltet. Den du tagger får varsel som før.",
        },
      ],
    },
  ],
};
